import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ADPResourceService } from 'digital-core';
import { SerialSearchRequestDto } from './serial-search-request.dto';
import { Observable } from 'rxjs';
import { SerialSearchResponseDto, SerialSearchResponseResultDto } from './serial-search-response.dto';
import { isEmpty as _isEmpty } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SerialSearchService {

  public constructor(
    private httpClient: HttpClient,
    private resourceService: ADPResourceService,
  ) { }

  public searchForEquipment(searchCriteria: SerialSearchRequestDto): Observable<SerialSearchResponseDto> {
    const options = {
      headers: new HttpHeaders({
        "Ocp-Apim-Subscription-Key": this.resourceService.getPortalSetting('SerialSearch_Api_SubscriptionKey').Value,
      }),
    };

    const url = this.resourceService.getPortalSetting('URL_SerialSearch_Api_Endpoint').Value;

    return this.httpClient.post<SerialSearchResponseDto>(url, searchCriteria, options);
  }

  /**
   * This returns true when every single entry in the Value property of the given
   * SerialSearchResponseResultDto was found from information related to the IMEI
   * (or serial number) that was provided when calling the API; otherwise this
   * returns false.
   *
   * @param serialSearchResults The SerialSearchResponseResultDto to evaluate
   * and determine if the equipment list contained inside contains only the
   * results related to the device with the IMEI / Serial number that was
   * provided when the search request was made.
   */
  public doesEquipmentListIncludeOnlyResultsForGivenImei(serialSearchResults: SerialSearchResponseResultDto) {
    if (serialSearchResults == null) {
      throw Error("serialSearchResults argument cannot be null or undefined.");
    }

    return !_isEmpty(serialSearchResults.appleEeeCode?.trim()) || !_isEmpty(serialSearchResults.modelName?.trim());
  }
}
